export const matches = [
    { label: 'All', value: 'all' },
    { label: 'No match', value: 'none' },
    { label: 'Single match', value: 'single' },
    { label: 'Multiple matches', value: 'multiple' },
];
